module.exports = __webpack_public_path__ + "img/mas_tarde.e7930cef.png";